import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Games from './pages/Games';
import Paintings from './pages/Paintings';
import Kids from './pages/Kids';
import Support from './pages/Support';
import Auction from './pages/Auction';
import Music from './pages/Music';
import HireArtist from './pages/HireArtist';
import HireDeveloper from './pages/HireDeveloper';
import Fashion from './pages/Fashion';
import Franchise from './pages/Franchise';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import VirtualTours from './pages/VirtualTours';
import Sponsorship from './pages/Sponsorship';
import MetaverseRental from './pages/MetaverseRental';
import Animation from './pages/Animation';
import AnimationGallery from './pages/AnimationGallery';
import AnimationQuote from './pages/AnimationQuote';
import Products from './pages/Products';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/animation" element={<Animation />} />
          <Route path="/animation-gallery" element={<AnimationGallery />} />
          <Route path="/animation-quote" element={<AnimationQuote />} />
          <Route path="/products" element={<Products />} />
          <Route path="/games" element={<Games />} />
          <Route path="/paintings" element={<Paintings />} />
          <Route path="/kids" element={<Kids />} />
          <Route path="/support" element={<Support />} />
          <Route path="/auction" element={<Auction />} />
          <Route path="/music" element={<Music />} />
          <Route path="/hire-artist" element={<HireArtist />} />
          <Route path="/hire-developer" element={<HireDeveloper />} />
          <Route path="/fashion" element={<Fashion />} />
          <Route path="/franchise" element={<Franchise />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/virtual-tours" element={<VirtualTours />} />
          <Route path="/sponsorship" element={<Sponsorship />} />
          <Route path="/metaverse-rental" element={<MetaverseRental />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;